<template>
    <div class="flex items-center justify-center h-full">
        <template v-if="documentMetaUuid">
            <UButton
                icon="i-ph-file-magnifying-glass"
                variant="ghost"
                color="neutral"
                size="xs"
                @click="onClickDocumentLink(documentMetaUuid)"
            />
            <UButton
                icon="i-ph-x"
                variant="ghost"
                color="neutral"
                size="xs"
                @click="onRemove"
            />
        </template>
        <template v-else>
            <UButton
                icon="i-ph-upload-simple"
                variant="ghost"
                color="neutral"
                size="xs"
                :loading="uploading"
                @click="fileInputRef?.click()"
            />
            <input
                ref="fileInputRef"
                type="file"
                class="hidden"
                @change="onFileSelected"
            >
        </template>
    </div>
</template>

<script setup lang="ts">
import {computed, ref} from 'vue'
import {fileUpload} from '@/services/document.service'
import {useDocumentPreviewModalService} from '@/transaction-journal/DocumentPreview.modal.service'
import {notifyError} from '@/services/infrastructure/notification.service'
import type {ReconciliationVedleggCellParams} from './ReconciliationListView.vue'

const {onClickDocumentLink} = useDocumentPreviewModalService()

const props = defineProps<{
    params: ReconciliationVedleggCellParams
}>()

const fileInputRef = ref<HTMLInputElement | null>(null)
const uploading = ref(false)

const documentMetaUuid = computed(() => props.params.value as string | null)

const onRemove = () => {
    props.params.context.onDocumentUpdated(props.params.data, null)
}

const onFileSelected = async (event: Event) => {
    const input = event.target as HTMLInputElement
    const file = input.files?.[0]
    if (!file) return
    uploading.value = true
    try {
        const doc = await fileUpload(file)
        props.params.context.onDocumentUpdated(props.params.data, doc.uuid)
    } catch {
        notifyError({title: 'Feil', description: 'Klarte ikke å laste opp dokumentet.'})
    } finally {
        uploading.value = false
        input.value = ''
    }
}
</script>
